import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { redirectDm2LoginToProdinent } from './utils/dm2SellerLoginRedirect';

import { Provider } from 'react-redux'
import { store, persistor } from './redux/store'
import { PersistGate } from 'redux-persist/es/integration/react';

if (!redirectDm2LoginToProdinent()) {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>,
  );
}
